import React, { useState } from 'react';
import '../../componentsStyling/Header.css';
import ProfileMenu from '../profileMenu/ProfileMenu';
import LogoImage from '../../assets/FSUlogo.png';
import {
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';

function Header({ userRole, userId, setIsAuthenticated }) {
  const [selectedButton, setSelectedButton] = useState('Reservations');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const handleButtonClick = (route) => {
    setSelectedButton(route);
    navigate(`/${route.toLowerCase()}`);
    setDrawerOpen(false);
  };

  const handleReload = () => {
    window.location.href = '/reservations'; // Or '/' if you prefer
  };

  const navItems = [
    { label: 'reservations' },
    { label: 'inventory' },
    ...(userRole !== 'ROLE_STUDENT'
      ? [{ label: 'students' }, { label: 'users' }]
      : [])
  ];

  return (
    <header className="header">
      <div className="header-content-left">
        <IconButton onClick={handleReload}>
          <img
            src={LogoImage}
            alt="Ferris State University Logo"
            className="header-icon"
          />
        </IconButton>
        <div className="title">
          <p>TDMP Media</p>
        </div>
      </div>

      <IconButton
        className="hamburger-icon"
        onClick={() => setDrawerOpen(true)}
      >
        <MenuIcon fontSize="large" />
      </IconButton>

      <nav className="nav-list">
        {navItems.map(({ label }) => (
          <button
            key={label}
            type="button"
            onClick={() => handleButtonClick(label)}
            className={`header-button ${
              selectedButton === label ? 'selected' : ''
            }`}
          >
            {label}
          </button>
        ))}
        <ProfileMenu
          userId={userId}
          setIsAuthenticated={setIsAuthenticated}
        />
      </nav>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <List className="drawer-list">
          {navItems.map(({ label }) => (
            <ListItem
              button
              key={label}
              onClick={() => handleButtonClick(label)}
              selected={selectedButton === label}
            >
              <ListItemText primary={label} />
            </ListItem>
          ))}
          <ListItem>
            <ProfileMenu
              userId={userId}
              setIsAuthenticated={setIsAuthenticated}
            />
          </ListItem>
        </List>
      </Drawer>
    </header>
  );
}

export default Header;
